import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTrendingUp = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3265 7.88338C20.2688 7.38604 19.8461 7 19.3332 7H15.3332V9H16.919L12.9999 12.919L10.3737 10.2929L10.2795 10.2097C9.88719 9.90468 9.31996 9.93241 8.95947 10.2929L3.95947 15.2929L5.37369 16.7071L9.66591 12.414L12.2928 15.0404L12.387 15.1236C12.7793 15.4287 13.3465 15.4009 13.707 15.0404L18.3331 10.4144L18.3332 12H20.3332V8L20.3265 7.88338Z"
        />
      </svg>
    );
  }
);
